<template>
	<div class="row">
		<div class="col-xs-12 text-center">
			<router-link v-if="!resume" :to="{ name: 'home' }" class="button button-3">{{
				$t('Link.GoToHomepage')
			}}</router-link>

			<router-link
				v-if="resume"
				:to="{ path: '/login', query: { redirect_to: '/request/create/1' } }"
				class="button button-6"
			>
				{{ $t('Link.InsertYourRequest') }}
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: 'BackToHome',
	props: {
		resume: {
			type: Boolean,
			default: false,
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/BackToHome.vue